import { FieldArrayType } from '@ngx-formly/core';
import { IExtraFieldConfigurationObject, IExtraTemplateOptions } from './ga-formly.service';

export abstract class ExtraFieldArray extends FieldArrayType {
  public to:IExtraTemplateOptions;
  public field:IExtraFieldConfigurationObject;
  public classNames:string;
}